// Copyright (c) 2017 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIM_SEARCH_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/claim-search/action-creators/get-claim-types.js